export default __webpack_public_path__ + "static/media/mailAlt.68aad554.svg";